import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestMarcasVeiculos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'marcasveiculos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteMarcasVeiculo({ payload }) {
  try {
    const { idmarcaveiculo, params } = payload;

    yield call(api.delete, `marcasveiculos/${idmarcaveiculo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(t(e)));
    else toast.error(t(erros));
  }
}

export function* store({ payload }) {
  try {
    const { marcasveiculo, params } = payload;

    yield call(api.post, 'marcasveiculos', marcasveiculo);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/marcasveiculos');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idmarcaveiculo } = payload;

    const { data } = yield call(api.get, `marcasveiculos/${idmarcaveiculo}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { marcasveiculo, params } = payload;

    yield call(api.put, 'marcasveiculos', marcasveiculo);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/marcasveiculos');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'marcasveiculos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@marcasveiculo/MARCASVEICULOS_IN_REQUEST', requestMarcasVeiculos),
  takeLatest('@marcasveiculo/DELETE_MARCASVEICULO', deleteMarcasVeiculo),
  takeLatest('@marcasveiculo/SUCCESS_REMOVE', requestMarcasVeiculos),
  takeLatest('@marcasveiculo/STORE_MARCASVEICULO', store),
  takeLatest('@marcasveiculo/FIND_MARCASVEICULO', find),
  takeLatest('@marcasveiculo/UPDATE_MARCASVEICULO', update),
  takeLatest('@marcasveiculo/RECORD_FILTERING', applyedFilters),
]);
